import { Controller, useFormContext } from 'react-hook-form'
import { BirthDate as BirthDateField } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { InputProps } from '../types'
import { useRouter } from 'next/router'
import { Language } from 'types/language'
import dayjs from 'dayjs'
import { checkIsValidDisplayDateNotation, convertDisplayDateToISO } from 'utils/dayjs'

const BirthDate = ({ required, name = 'dateOfBirth', ...props }: InputProps & { name?: string }) => {
  // React Hook Form
  const { register, control } = useFormContext()

  // Router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  return (
    <Controller
      {...{ name, control }}
      render={({ field, formState }) => (
        <BirthDateField
          {...props}
          {...register(name, {
            required: { value: required, message: t('validation:required') },
            validate: {
              valid: (value) =>
                (!required && !value) ||
                checkIsValidDisplayDateNotation(value as string) ||
                t('commonFormFields:dateOfBirth.errors.invalid'),
              minAge: (date) => {
                if (!date) return true
                const isoDate = convertDisplayDateToISO(date)
                return dayjs(isoDate).isBefore(dayjs().subtract(18, 'years')) || t('commonFormFields:dateOfBirth.errors.min18')
              },
              magAge: (date) => {
                if (!date) return true
                const isoDate = convertDisplayDateToISO(date)
                return dayjs(new Date(isoDate)).isAfter(dayjs('1900-01-01')) || t('commonFormFields:dateOfBirth.errors.maxAge')
              }
            }
          })}
          value={field.value}
          onChange={field.onChange}
          error={formState?.errors?.[name]?.message as string | undefined}
          label={t('commonFormFields:dateOfBirth.label')}
          language={locale === Language.FRENCH ? 'fr' : 'nl'}
          {...(!required && { optionalText: t('common:optional') })}
        />
      )}
    />
  )
}

export default BirthDate
